import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';

import './CompanyCard.scss';

export default class CompanyCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * logo information
         */
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        /**
         * url information
         */
        url: PropTypes.string,
        /**
         * id
         */
        partnerId: PropTypes.number,
        /**
         * name
         */
        partnerName: PropTypes.string,
    };

    render() {
        const injectedTransforms = {
            xSmall: 'c_lpad,f_auto,q_auto,w_120,h_93',
        };
        const imagePath = buildImagePath(
            this.props.logo.src,
            'xSmall',
            injectedTransforms
        );
        return (
            <div className="component-Partners-CompanyCard">
                <a className="company-link" href={this.props.url}>
                    <img className="company-image" src={imagePath} />
                    <div className="company-name">
                        {truncateWithEllipsis(this.props.partnerName, 30)}
                    </div>
                </a>
            </div>
        );
    }
}
